import { NewPBLPage } from '@hendrx/core/pbl/pages/NewPBLPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/pbl/new')({
  component: NewPBLPage
});
